import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, SettingsIcon, BarChart3Icon } from 'lucide-react';
const steps = [{
  icon: DownloadIcon,
  title: 'Download & Open',
  description: 'Get instant access after purchase. Open in Google Sheets or Excel — your choice.',
  color: 'bg-gradient-teal',
  num: '1'
}, {
  icon: SettingsIcon,
  title: 'Set Up in 3 Minutes',
  description: 'Follow the simple setup guide. Enter your products, costs, and platforms. Done.',
  color: 'bg-[#0D1A35]',
  num: '2'
}, {
  icon: BarChart3Icon,
  title: 'See Your Numbers',
  description: 'Watch your dashboard come alive with real profit data, inventory alerts, and insights.',
  color: 'bg-gradient-gold',
  num: '3'
}];
export function HowItWorks() {
  return <section className="bg-white py-20" data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-178">
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900" data-id="element-179">
            Up and Running in{' '}
            <span className="text-gradient-teal" data-id="element-180">5 Minutes</span>
          </h2>
        </motion.div>

        <div className="relative grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-181">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-10 left-[20%] right-[20%] h-[2px] border-t-2 border-dashed border-gray-200" data-id="element-182" />

          {steps.map((step, i) => <motion.div key={step.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15,
          duration: 0.5
        }} className="text-center relative" data-id="element-183">
              <div className={`w-20 h-20 ${step.color} rounded-full flex items-center justify-center mx-auto mb-5 relative z-10`} data-id="element-184">
                <step.icon className="w-8 h-8 text-white" data-id="element-185" />
              </div>
              <span className="text-xs font-bold text-gray-300 uppercase tracking-widest mb-2 block" data-id="element-186">
                Step {step.num}
              </span>
              <h3 className="font-display font-bold text-lg text-gray-900 mb-2" data-id="element-187">
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed max-w-xs mx-auto" data-id="element-188">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}